import React from 'react';
import { Box } from '@mui/material';

import LogoSvg from '@/shared/assets/logo.svg';
import LogoSvgHorizontal from '@/shared/assets/logo_horizontal.svg';
import LogoSvgHorizontalDark from '@/shared/assets/logo_horizontal_dark.svg';
import LogoMarkSvg from '@/shared/assets/logo_mark.svg';

type TLogoProps = {
  variant?: 'primary' | 'secondary' | 'secondary-dark' | 'mark';
  sx?: React.CSSProperties;
};

export const Logo = ({ variant = 'primary', sx }: TLogoProps) => {
  return (
    <Box sx={sx}>
      {variant === 'primary' ? <LogoSvg /> : null}
      {variant === 'secondary' ? <LogoSvgHorizontal /> : null}
      {variant === 'secondary-dark' ? <LogoSvgHorizontalDark /> : null}
      {variant === 'mark' ? <LogoMarkSvg /> : null}
    </Box>
  );
};
